import mutations from './accountDivisionMutation';
import actions from './accountDivisionAction';
import getters from './accountDivisionGetter';

const state= {
  accountTrendList: [],
  accountDiffList: [],
  accountStatusList: [],
  accountCspStatusList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/summary/accountDivisionStore.js